import { ContentArticle } from '../types';
import banner from '../assets/default-banner.jpg';
import { Author as Trey } from '../authors/trey';

const body = (
  <>
    <details open className='bg-content cursor-pointer rounded-lg border border-gray-600'>
      <summary className='row-auto px-6 py-4 text-xl italic'>Release version 1.1.0</summary>
      <ul className='row-auto list-disc space-y-4 px-16 pb-8 pt-2'>
        <li>1080p Streaming Resolution: Now available for improved visual quality during streaming.</li>
        <li>
          CPU Performance Reservation: Playcast now allocates CPU resources to maintain smooth gameplay performance, especially during
          intensive gaming.
        </li>
        <li>Adjusted streaming settings to provide a more stable framerate across various conditions.</li>
        <li>Improved capture rates for smoother streaming experiences.</li>
        <li>
          Adaptive framerate and V-Sync settings on compatible NVIDIA and AMD graphics cards to ensure optimal streaming quality while
          Playcast is active.
        </li>
        <li>Increased the speed of message capture in the host app for a more responsive experience.</li>
        <li>Enhanced desktop surfing performance for a seamless user experience.</li>
        <li>Fixed an issue causing streams to crash on Firefox clients.</li>
        <li>Resolved several visual inconsistencies across the app for a more cohesive look and feel.</li>
        <li>Fixed slow connection issues by refining connection logic.</li>
        <li>Addressed sensitivity issues with WebRTC quality settings.</li>
        <li>Corrected issues with SMS and email limits not registering correctly.</li>
        <li>Fixed a performance issue affecting AMD graphics cards.</li>
      </ul>
    </details>

    <details open className='bg-content cursor-pointer rounded-lg border border-gray-600'>
      <summary className='row-auto px-6 py-4 text-xl italic'>Release version 1.0.0</summary>
      <ul className='row-auto list-disc space-y-4 px-16 pb-8 pt-2'>
        <li>Updated version number to 1</li>
        <li>Over 1800 commits with amazing new changes</li>
        <li>Reworked host app user interface for clarity and simplicity</li>
        <li>Complete rework of invitation, knock (don't know what that is? ask on Discord), and queueing system</li>
        <li>Fix issues with drivers and install (and uninstall, but who needs that?)</li>
        <li>Move all authentication to social media or OTP options (now passwordless!)</li>
        <li>Update peer-to-peer library with quality control and WebRTC "tweak" capability for improved performance</li>
        <li>Add multiple audio tracks for desktop audio and microphone</li>
        <li>Add no-video option that uses a static image, but pulled it out at the last second, making Trey sad (coming back soon!)</li>
        <li>Add support for inviting friends via email or SMS (Twilio defeated!)</li>
        <li>Use multiple cameras so that devices receive streams at appropriate resolutions</li>
        <li>Add support for getting to the remote dashboard from the app</li>
        <li>Tons of little bug fixes and probably more features I'm not remembering because it's late</li>
      </ul>
    </details>

    <details open className='bg-content cursor-pointer rounded-lg border border-gray-600'>
      <summary className='row-auto px-6 py-4 text-xl italic'>Beta version 0.17.0</summary>
      <ul className='row-auto list-disc space-y-4 px-16 pb-8 pt-2'>
        <li>
          The host can now be managed remotely from a dashboard - hosts won't need to tab out of a game to make changes, but can use a
          separate device, like a phone, for that
        </li>
        <li>The host application has been visually overhauled for a more intuitive design</li>
        <li>More improvements on the mobile on-screen gamepad (but keep suggesting!)</li>
        <li>Mouse accessibility and color accuracy improved</li>
        <li>Updated default WebRTC settings that will produce better video quality for most devices and available bandwidth</li>
        <li>
          Improvements to our display capture to improve video quality (that's right, orthographic projection to eliminate a slight
          curvature distortion introduced by leveraging 3D capture instead of 2D, introduced a few versions back)
        </li>
        <li>A hot new website, which you know because you're on it right now</li>
        <li>Social media accounts and links (follow us on your favorite platforms to keep up to date!)</li>
      </ul>
    </details>

    <details className='bg-content cursor-pointer rounded-lg border border-gray-600'>
      <summary className='row-auto px-6 py-4 text-xl italic'>Beta version 0.16.0</summary>
      <ul className='row-auto list-disc space-y-4 px-16 pb-8 pt-2'>
        <li>
          The on-screen gamepad for mobile devices now includes bumpers and triggers, plus some improvements to visibility. (We value your
          feedback, this is still a work in progress.)
        </li>
        <li>Fixed a number of keyboard mapping fixes you never noticed because they are keys that are almost never used.</li>
        <li>
          Fixed some rendering issues with some mouse cursors, some of which were displaying in inverse coloring, for example. Grabby hand
          may still be not quite right, like when hovering over YouTube subtitles, a thing you definitely noticed and were frustrated about.
        </li>
        <li>
          More improvements to the installer. Also, improved the uninstaller that you probably won't use, because this super great software.
        </li>
        <li>Reduced bandwidth requirements for gamepad data by not sending updates where state has not changed.</li>
        <li>Fixed a bug where the display picker did not always show the correct display information at startup.</li>
        <li>Fixed a bug where a duplicate cursor was shown during drag operations, which itself was also a drag.</li>
        <li>
          Fixed a bug where the cursor would sometimes appear comically large, not just because Alex was using a commically large cursor,
          but other times, too.
        </li>
        <li>Fixed issues related to proper recognition of number pad keys based on NumLock state.</li>
        <li>A ton of smaller bug fixes and minor improvements</li>
        <li>
          Quite a bit of new work on infrastructure to support forthcoming remote-control features for hosts and automation for players to
          use Windows guest accounts created on the fly. Stay tuned for more on this - really good stuff!
        </li>
      </ul>
    </details>

    <details className='bg-content cursor-pointer rounded-lg border border-gray-600'>
      <summary className='row-auto px-6 py-4 text-xl italic'>Beta version 0.15.0</summary>
      <ul className='row-auto list-disc space-y-4 px-16 pb-8 pt-2'>
        <li>
          A new on-screen gamepad for mobile devices loads for players connecting to a host that allows gamepad input when the player
          doesn't have a connected physical gamepad.
        </li>
        <li>
          Swapped out the Unity WebGL system for input capture with an improved, lighter-weight Playcast input capture that means smaller
          memory footprint for players and fewer data transformations, improving input speed
        </li>
        <li>
          The underlying screen capture has been completely overhauled to use a GPU-driven, 3D capture instead of a CPU-driven 2D capture
          system.
        </li>
        <li>
          Mouse cursors are now consistent and free of flickering (a problem you may see across many screen sharing applications using
          Chromium browsers - we fixed it for Playcast!)
        </li>
        <li>Improved installer that resolves many issues with file placements and drivers</li>
        <li>A ton of smaller bug fixes and minor improvements</li>
      </ul>
    </details>

    <details className='bg-content cursor-pointer rounded-lg border border-gray-600'>
      <summary className='row-auto px-6 py-4 text-xl italic'>Beta version 0.13.0</summary>
      <ul className='row-auto list-disc space-y-4 px-16 pb-8 pt-2'>
        <li>Clear differentiation between "player" mode and "spectator" mode</li>
        <li>
          Player mode puts the browser into full screen mode, locks the cursor, and locks the keyboard (exit by holding Esc for a few
          seconds)
        </li>
        <li>
          The feature above means that in games where you crouch with Ctrl and then move forward with W, that Ctrl-W doesn't just close the
          browser
        </li>
        <li>Lower latency and improved overall video stream</li>
        <li>TURN server support for access across more complex network environments</li>
        <li>Solved a video hitching issue caused by encoding conflicts in certain versions of Chromium</li>
        <li>Infrastructure updates to support forthcoming features: on-screen mobile gamepad, headless mode, remote control</li>
        <li>Upgrades to Electron, Chromium, and other packages</li>
      </ul>
    </details>

    <h2 className='col-span-10 col-start-2 text-3xl'>Alpha Releases</h2>
    <p className='col-span-10 col-start-2 -mt-4'>
      If you are running an Alpha version (anything prior to v0.13.0), you should fully uninstall the Playcast Host and reboot before
      installing this new version. While we have generally attempted to make that not required, in some instances, the earlier Alpha
      versions have interfered with the latest.
    </p>

    <details className='bg-content cursor-pointer rounded-lg border border-gray-600'>
      <summary className='row-auto px-6 py-4 text-xl italic'>Alpha version 0.10.80</summary>
      <ul className='row-auto list-disc space-y-4 px-16 pb-8 pt-2'>
        <li>Fix for a small padding around player video causing not-quite-full-screen</li>
        <li>A number of small fixes that are basically not visible to users, so you probably don't care about them</li>
        <li>A change that has the commit message "irrelevant change", which I only mention because that's super funny</li>
      </ul>
    </details>

    <details className='bg-content cursor-pointer rounded-lg border border-gray-600'>
      <summary className='row-auto px-6 py-4 text-xl italic'>Alpha version 0.10.71</summary>
      <ul className='row-auto list-disc space-y-4 px-16 pb-8 pt-2'>
        <li>Fix for occasional black screen output when initiating a new stream</li>
        <li>Fix for white spots showing up in video stream when mouse is moving</li>
        <li>Fix for some mis-mapped keys</li>
        <li>Fix for repeat key handling</li>
        <li>Fix gamepad assignment when a remote player has multiple gamepads</li>
        <li>Fix latency issue when remote player has multiple gamepads</li>
        <li>Fix gamepad assignments when players connect or disconnect gamepads (which includes a gamepad running out of battery)</li>
        <li>Fix mouse mapping when mouse is moved across multiple displays</li>
        <li>
          Add mouse mode option (not yet available via UI) to allow remote player to mouse across multiple displays and have video stream
          switch to the display where the mouse is
        </li>
        <li>Mouse should be visible to players all the time now</li>
        <li>Cull player input that has no state change to reduce bandwidth usage from player to host</li>
        <li>
          Add support for multiple virtual cameras (ShadowCam) as an infrastructure improvement that will open the door for more flexible
          streaming options
        </li>
        <li>Better mouse mapping especially for games that run in full screen mode, and generally better all around</li>
        <li>Fixed a multitude of bugs that could lead to a Playjector crash</li>
        <li>Allow a host to kick a player because the player has gone idle or is just a bad person</li>
        <li>Hid experimental features unless you know how to unlock them - want to try them? Ask us in Discord!</li>
        <li>
          While video output remains always 16:9 aspect ratio (for now!), added proper scaling and matte to transmission of displays that
          are not at that aspect ratio (most notably, ultra-wide monitors)
        </li>
        <li>Ongoing improvements to lower latency on video capture</li>
        <li>
          Restored capability to direct all gamepads to the first gamepad to allow remote "hot seat" games where the controller is passed
          around between players
        </li>
        <li>
          Because proper mouse capture requires Pointer Lock in the player's browser, mouse input only transmits when the pointer is locked
        </li>
        <li>Added a button to make it clear when Pointer Lock is active or not and make locking the mouse way easier</li>
        <li>Improved player connection user experience to be more clear about what's going on at each step</li>
        <li>
          Host IDs are now generated to be unique to each session, securing hosts from unwanted intrusion by players aware of previously
          used IDs
        </li>
        <li>Integration with Auth0 to support authentication and security features to protect host computers from malicious attacks</li>
        <li>New authentication requirements (or explicit opt-out) when running the host app on a Windows account with admin rights</li>
        <li>Player ID management to further secure and validate connections to hosts through use of validation tokens</li>
      </ul>
    </details>

    <details className='bg-content cursor-pointer rounded-lg border border-gray-600'>
      <summary className='row-auto px-6 py-4 text-xl italic'>Alpha version 0.10.32</summary>
      <ul className='row-auto list-disc space-y-4 px-16 pb-8 pt-2'>
        <li>Streamlined the dashboard to simplify getting started</li>
        <li>New player page with improved input capture</li>
        <li>The player page uses PointerLock to capture the mouse and pass input as deltas for interpretation by the host</li>
        <li>Players can provide a name so hosts know who is joining</li>
        <li>Gamepad connections by remote players are tracked and assigned to local gamepads more consistently</li>
        <li>All input latency has been reduced</li>
        <li>Video capture latency has been reduced</li>
        <li>A wide array of new ShadowCam capture features are added (but mostly accessible only through Experimental)</li>
        <li>Mouse input maps far more accurately to the target shared display</li>
        <li>The host cursor is captured and included in the broadcast video</li>
        <li>
          The host can hit the Pause key to immediately halt all incoming player input (useful when players have mouse control and Just.
          Won't. Stop.)
        </li>
        <li>
          Complete overhaul of internal messaging systems that you totally don't care about, but people who later want to integrate with a
          Playcast API will appreciate greatly
        </li>
        <li>
          Complete overhaul of state management in both player and host that you also totally don't care about, but solves a wide array of
          problems related to how React manages state when components re-render
        </li>
        <li>Improved WebRTC connection management and messaging between host and players</li>
        <li>
          Infrastructure to support authentication that you won't actually see in the UI quite yet, but is going to unlock a lot of new
          features soon
        </li>
      </ul>
    </details>

    <details className='bg-content cursor-pointer rounded-lg border border-gray-600'>
      <summary className='row-auto px-6 py-4 text-xl italic'>Alpha version 0.9.38</summary>
      <ul className='row-auto list-disc space-y-4 px-16 pb-8 pt-2'>
        <li>Improved installer, new messaging to ensure users reboot after an uninstall and after a fresh install</li>
        <li>Major video performance, robustness and smoothness improvements -Support for multiple displays and capture modes</li>
        <li>Enhanced logging support</li>
        <li>Experimental page expanded to support more in-development features</li>
        <li>Shared single player game controller support</li>
        <li>Not all capture mode changes working but that bug should be fixed in a quick update</li>
        <li>Better installer</li>
      </ul>
    </details>

    <details className='bg-content cursor-pointer rounded-lg border border-gray-600'>
      <summary className='row-auto px-6 py-4 text-xl italic'>Alpha version 0.9.15</summary>
      <ul className='row-auto list-disc space-y-4 px-16 pb-8 pt-2'>
        <li>
          Improved installer to solve driver issues if Visual C++ Redistributables are not present already on the target host computer
        </li>
      </ul>
    </details>

    <details className='bg-content cursor-pointer rounded-lg border border-gray-600'>
      <summary className='row-auto px-6 py-4 text-xl italic'>Alpha version 0.9.13</summary>
      <ul className='row-auto list-disc space-y-4 px-16 pb-8 pt-2'>
        <li>Less crashing!</li>
        <li>Added toggles to manage logging</li>
        <li>Added toggle to enable disable mouse capture</li>
        <li>You can select any desktop display to stream from via the ShadowCam</li>
        <li>General and per player input controls added</li>
        <li>Latency and framerates dramatically improved</li>
        <li>New cleaner installer</li>
        <li>Experimental tab was added to the console to support diagnostics and testing</li>
      </ul>
    </details>

    <details className='bg-content cursor-pointer rounded-lg border border-gray-600'>
      <summary className='row-auto px-6 py-4 text-xl italic'>Alpha version 0.9.2</summary>
      <ul className='row-auto list-disc space-y-4 px-16 pb-8 pt-2'>
        <li>Added release notes and about pages</li>
        <li>Added visible version number</li>
        <li>Better labeling of what stream source is current</li>
        <li>Host can now set whether or not the cursor displays over the video on player pages</li>
        <li>Host can now select all values on Playcast Data (helps when needing support)</li>
        <li>Added feedback mechanism</li>
        <li>Better clarity around which services are running</li>
        <li>ShadowCam is now the default camera (and will show your primary desktop)</li>
        <li>PlayJector will only start when the host starts, and closes when the host closes</li>
        <li>PlayJector will use notably less CPU and will no longer consume all CPU over time (we found a leak and fixed it!)</li>
        <li>
          Mouse input will always be pinned to the primary monitor and broadcast at 1080p (but note that ShadowCam doesn't show the mouse
          right now, so leave "Show player's mouse" on unless you - have reason to do otherwise)
        </li>
        <li>Mouse mapping works great on anything with 16:9 aspect ratio (if you are using something else and having problems, tell us)</li>
        <li>
          When using ShadowCam, you can change your primary monitor and the stream and mouse input automatically switch to that without the
          stream needing to restart
        </li>
        <li>When using ShadowCam, changing screen resolutions (like when starting a game) should work well and not break your stream</li>
      </ul>
    </details>

    <details className='bg-content cursor-pointer rounded-lg border border-gray-600'>
      <summary className='row-auto px-6 py-4 text-xl italic'>Alpha version 0.9.1</summary>
      <ul className='row-auto list-disc space-y-4 px-16 pb-8 pt-2'>
        <li>Fixed: App no longer starts off screen</li>
      </ul>
    </details>

    <details className='bg-content cursor-pointer rounded-lg border border-gray-600'>
      <summary className='row-auto px-6 py-4 text-xl italic'>Alpha version 0.9.0</summary>
      <ul className='row-auto list-disc space-y-4 px-16 pb-8 pt-2'>
        <li>Initial release!</li>
      </ul>
    </details>
  </>
);

export const Changelog: ContentArticle = {
  title: `Change Log`,
  slug: 'changelog',
  published: '2024-03-04',
  author: Trey,
  banner: banner,
  summary: 'List of changes in current and prior versions',
  body: body,
};
